import { createFileRoute, notFound } from "@tanstack/react-router";

import { ComparePage } from "../components/compare/ComparePage";
import { compareHead } from "../lib/compare/head";
import { compareSlugOf, loadCompareCopy } from "../lib/compare/index";
import { COMPARE_UI } from "../lib/compare/ui";
import { documentHeaders } from "../lib/seo";

/**
 * `/compare/<slug>`, in English.
 *
 * v1 published these at `/fazly-vs-<slug>`; `lib/compare/index.ts` records why
 * that address could not survive the router's ranking rules, and
 * `lib/legacyPaths.ts` 301s the old form here.
 */
export const Route = createFileRoute("/compare/$slug")({
  loader: async ({ params }) => {
    const slug = compareSlugOf(params.slug);
    if (!slug) throw notFound();
    return { slug, copy: await loadCompareCopy("en") };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? compareHead(
          loaderData.slug,
          "en",
          loaderData.copy[loaderData.slug],
          COMPARE_UI.en,
        )
      : {},
  component: EnglishCompare,
});

function EnglishCompare() {
  const { slug, copy } = Route.useLoaderData();
  return (
    <ComparePage
      slug={slug}
      copy={copy[slug]}
      ui={COMPARE_UI.en}
      lang="en"
      allCopy={copy}
    />
  );
}
